import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useAuthState, Loading, useRedirect, useNotify } from 'react-admin';
import AppBar from './appbar';
import * as Auth from '../../api';
import SignUpForm from './form';
import LegalAgreement from './legal-agreement';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(10),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  label: {
    cursor: 'pointer',
    fontSize: 14,
  },
}));

const SignUp = (props) => {
  const classes = useStyles();
  const { loading, authenticated } = useAuthState();
  const redirect = useRedirect();
  const notify = useNotify();
  const { token } = props.match.params;

  const [submitErrors, setSubmitErrors] = useState([]);
  const [formData, setFormData] = useState(null);

  const onFormSubmit = (data) => {
    setFormData(data);
  };

  const onSignUp = async () => {
    try {
      await Auth.signUp(token, formData);
      notify('You registered successfully. Please Sign In.');
      redirect('/login');
    } catch (e) {
      setFormData(null);
      const { errors } = e.response.data;
      setSubmitErrors(errors);
    }
  }

  const [tokenIsValid, setTokenIsValid] = useState(true);

  useEffect(() => {
    const checkSignUpToken = async () => {
      try {
        await Auth.checkSignUpToken(token);
      } catch (e) {
        setTokenIsValid(false);
      }
    };
    checkSignUpToken();
  }, [token]);

  if (loading) {
    return <Loading />;
  }
  if (authenticated || !tokenIsValid) {
    redirect('/');
    return null;
  }  
  return (
    <Container component="main" maxWidth="md">
      <AppBar />
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign up
        </Typography>
        {!formData &&
          <SignUpForm onSubmit={onFormSubmit} classes={classes} submitErrors={submitErrors} />
        }
        {formData && 
          <LegalAgreement onSubmit={onSignUp} />
        }
      </div>
    </Container>
  );
};

export default withRouter(SignUp);
